import axios from "axios";
import authHeader from "../auth-header";
import ConstApiUrls from "../const-api-urls";

const API_URL = ConstApiUrls.API_SERVICE_URL_UMKM

class FtUmkmPermitService {
  getApiUrl() {
    return API_URL;
  }
  getAllFtUmkmPermit() {
    return axios.get(API_URL + `getAllFtUmkmPermit`, { headers: authHeader() });
  }
  getAllFtUmkmPermitByCompany() {
    return axios.get(API_URL + `getAllFtUmkmPermitByCompany`, {
      headers: authHeader(),
    });
  }

  getAllFtUmkmPermitByParent(id) {
    return axios.get(API_URL + `getAllFtUmkmPermitByParent/${id}`, {
      headers: authHeader(),
    });
  }
  getAllFtUmkmPermitByParentPublic(id) {
    return axios.get(API_URL + `public/getAllFtUmkmPermitByParent/${id}`, {
      headers: authHeader(),
    });
  }
  getAllFtUmkmPermitByFPsuSimple(id) {
    return axios.get(API_URL + `public/getAllFtUmkmPermitByFPsuSimple/${id}`, {
      headers: authHeader(),
    });
  }
  getAllFtUmkmPermitContaining(page, pageSize, sortBy, order, search) {
    // return axios.get(API_URL + `getAllFtUmkmPermit`, { headers: authHeaderMultipart() });
    return axios.get(
      API_URL +
        `getAllFtUmkmPermitContaining?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&order=${order}&search=${search}`,
      { headers: authHeader() }
    );
  }
  getAllFtUmkmPermitContainingPublic(page, pageSize, sortBy, order, search) {
    // return axios.get(API_URL + `getAllFtUmkmPermit`, { headers: authHeaderMultipart() });
    return axios.get(
      API_URL +
        `public/getAllFtUmkmPermitContaining?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&order=${order}&search=${search}`,
      { headers: authHeader() }
    );
  }
  getFtUmkmPermitById(id) {
    return axios.get(API_URL + `getFtUmkmPermitById/${id}`, {
      headers: authHeader(),
    });
  }
  updateFtUmkmPermit(item) {
    return axios.put(API_URL + `updateFtUmkmPermit/${item.id}`, item, {
      headers: authHeader(),
    });
  }
  createFtUmkmPermitMultiple(items) {
    return axios.post(API_URL + `createFtUmkmPermitMultiple`, items, {
      headers: authHeader(),
    });
  }
  createFtUmkmPermit(item) {
    return axios.post(API_URL + `createFtUmkmPermit`, item, {
      headers: authHeader(),
    });
  }
  deleteFtUmkmPermit(id) {
    return axios.delete(API_URL + `deleteFtUmkmPermit/${id}`, {
      headers: authHeader(),
    });
  }
  deleteAllFtUmkmPermit(itemIds) {
    return axios.delete(API_URL + `deleteAllFtUmkmPermit`, {
      headers: authHeader(),
      data: itemIds,
    });
  }

  deleteAllFtUmkmPermitByParent(umkmBean) {
    return axios.delete(API_URL + `deleteAllFtUmkmPermitByParent/${umkmBean}`, {
      headers: authHeader(),
    });
  }
}
export default new FtUmkmPermitService();
